import e from"styled-components";const i=e.div`
	background-image: ${({backgroundURL:e})=>`url(${e})`};
	background-size: cover;
	background-position: center;
	width: 100%;
	height: ${({isTemplate:e,isMagazine:i})=>e?i?"110px":"70px":i?"240px":"170px"};
	border-radius: ${({borderRadius:e})=>"number"==typeof e?e:14}px;
`,t=e.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: ${({isTemplate:e})=>e?"3.179px":" 16px 8px 8px 8px"};
	gap: ${({isTemplate:e})=>e?"9.5px":"12px"};
	flex: 1;
`,p=e.div`
	display: flex;
	flex-direction: column;
	gap: ${({isTemplate:e})=>e?"3px":"8px"};
`,o=e.div`
	display: flex;
	flex-direction: column;
	gap: ${({isTemplate:e})=>e?"1px":"12px"};
	flex-grow: 1;
`,l=e.img`
	width: ${({isTemplate:e})=>e?"8.344px":"20px"};
	height: ${({isTemplate:e})=>e?"8.344px":"20px"};
	border-radius: 50px;
	object-fit: cover;
`,a=e.div`
	display: flex;
	flex-flow: row;
	align-items: center;
	gap: ${({isTemplate:e})=>e?"4px":"8px"};
`,n=e.div`
	color: #999;
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"5.116px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: 20px;
`,r=e.div`
	background: #999;
	width: ${({isTemplate:e})=>e?"1.589px":"4px"};
	height: ${({isTemplate:e})=>e?"1.589px":"4px"};
	border-radius: 50%;
`,s=e.div`
	color: ${({theme:e})=>e.text.title};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e,isMagazine:i})=>e?i?"10px":"8.7px":"22px"};
	font-style: normal;
	font-weight: 500;

	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`,x=e.div`
	color: #999;
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"5.563px":"15px"};
	font-style: normal;
	font-weight: 400;
	line-height: ${({isTemplate:e})=>e?"7.152px":"130%"};

	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`,d=e.div`
	display: flex;
	flex-flow: row;
	align-items: center;
	gap: 4px;
	overflow: hidden;
	position: relative;

	&::after {
		content: '';
		position: absolute;
		right: 0;
		top: 0;
		width: 40px;
		height: 100%;
		pointer-events: none;
		background: ${({theme:e})=>`linear-gradient(90deg, transparent 0%, ${e.bg.card} 100%);`};
	}
`,m=e.div`
	display: flex;
	padding: ${({isTemplate:e})=>e?"1.589px 3.179px":"2px 6px"};
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 100px;
	background: ${({colors:e,theme:i})=>e.accent[i.name].slice(0,7)+"4D"};
	color: ${({colors:e,theme:i})=>e.accent[i.name]};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"5.166px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"7px":"16px"};
	white-space: nowrap;
`,c=e.div`
	display: flex;
	padding: ${({isTemplate:e})=>e?"1.589px 3.179px":"2px 6px"};
	justify-content: center;
	align-items: center;
	gap: 10px;
	border-radius: 100px;
	background: ${({colors:e,theme:i})=>e.accent[i.name]};
	color: ${({colors:e,theme:i})=>e.text[i.name]};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"5.166px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"7px":"16px"};
	white-space: nowrap;
`;export{n as Author,a as AuthorWrapper,t as CardContent,o as CardGrowContent,p as CardMiddleContent,x as Description,r as Divider,i as ImageContainer,m as Label,l as NewsAvatar,c as Space,d as TagWrapper,s as Title};
